/*
 * @Descripttion: 关联项目信息
 * @Author: renbh
 * @Date: 2023-05-05 15:38:16
 * @LastEditors: 黄佳鑫
 * @LastEditTime: 2026-02-10 09:42:57
 */

import React, { useEffect, useState, useRef } from 'react'
import { Form, Select, Tooltip, Button } from 'antd'
import { FormInstance } from 'antd/lib/form'
import { useTypedSelector } from '../../redux/store'
import { PlatformField } from './reducer'
import Styles from './detail.module.scss'
import GoodsSubmissionInfo from './goodsSubmissionInfo.tsx'
import {
  GET_PROJECT_FIELD,
  QualityList,
  ReportFieldConfigVO,
  ReportFieldValueSubmitDTO,
} from '@/api/reportApi'
import { reportTypeEnumValue, materialTypeEnum } from '@/global/enum/product'
import { mergePlatformList } from '@/tools/util'
import { PreCheckErrors } from '@/api/MaterialApi'
import { NOT_SELECT_PLATFORM } from '@/enum'
import ProjectValidationInfo from '@/pages/materialSubmissionManage/ProjectValidationInfo'

export type ItemFieldsType =
  // 单选
  | '1'
  // 多选
  | '2'
  // 下拉
  | '3'
  // 文本
  | '4'
  // 多选级联
  | '5'

interface Props {
  form: FormInstance
  normalForm: FormInstance
  itemsList: PlatformField[]
  readOnly?: boolean
  changeItemList: (val: PlatformField[]) => void
  isEditView?: boolean // 是否为编辑页面
  displayDelBtnIndex?: number // 隐藏删除按钮
  changeList?: boolean
  onFieldsChange: () => void
  submissionType?: reportTypeEnumValue
  qualityDataList: QualityList[]
  setQualityDataListAction: (data: QualityList[]) => void
  isDetailPage?: boolean // 是否为详情页面
  preCheckErrors?: PreCheckErrors
  reportingType?: string
  onReportConfigChange?: (fields: ReportFieldConfigVO[]) => void
  reportFieldValues?: ReportFieldValueSubmitDTO[]
  relateFieldKeySet?: Set<string>
  onRelateFieldBlur?: (fieldKey: string, value: any) => void
}

const AssociationItems: React.FC<Props> = (props) => {
  const {
    form,
    normalForm,
    itemsList = [],
    readOnly = false,
    changeItemList,
    changeList,
    onFieldsChange,
    submissionType,
    qualityDataList,
    setQualityDataListAction,
    isDetailPage,
    preCheckErrors,
    isEditView,
    reportingType,
    onReportConfigChange,
    reportFieldValues,
    relateFieldKeySet,
    onRelateFieldBlur,
  } = props

  const { platformList, connectedProjectData } = useTypedSelector(
    (state) => state.goodsReducer,
  )
  // 监听 productType 字段值
  const productType = Form.useWatch('productType', normalForm)
  // 过滤后的平台列表
  const [filteredPlatformList, setFilteredPlatformList] =
    useState<PlatformField[]>(platformList)

  // 判断当前项目是否展示折扣，默认取 itemsList 第一项的 showDiscountRate
  const [showRate, setShowRate] = useState<'1' | '0'>(
    () => (itemsList[0]?.showDiscountRate ?? '0') as '1' | '0',
  )
  // 当前选中的项目（单选）
  const [currentSelectedItem, setCurrentSelectedItem] =
    useState<PlatformField | null>(itemsList.length > 0 ? itemsList[0] : null)
  // 上一次的 productType，用于检测变化
  const prevProductTypeRef = useRef<string | undefined>(productType)
  // 标记 productType 是否刚刚变化，需要检查选中项
  const needCheckSelectedItemRef = useRef<boolean>(false)

  /**
   * 数据来源说明：
   * - 供应商物料：platformList 与接口GET_CONNECTED_PROJECT_CODE数据合并去重后的数据
   * - 电商供应商物料：platformList 的全部数据
   *
   * 数据关系：
   * - 电商供应商物料的数据在供应商物料中一定存在
   * - 供应商物料的数据不一定在电商供应商物料中存在
   *
   * 切换逻辑：
   * - 电商供应商 → 供应商：选中数据保持不变（因为电商供应商数据在供应商中一定存在）
   * - 供应商 → 电商供应商：校验选中数据是否存在，存在则保持不变，不存在则清空
   *
   * 设计说明：
   * connectedProjectData 已在登录时通过 Redux 缓存，无需每次切换类型时重新获取。
   * 当前未实现分别缓存各类型数据的功能，如需实现需要缓存两份数据并修改父组件逻辑，影响面较大。
   * (已与侯夏琳沟通过该需求，若后续有强烈需求，需要重新设计。)
   */

  useEffect(() => {
    if (materialTypeEnum.isLabelsMatchValue(['供应商物料'], productType)) {
      setFilteredPlatformList(
        mergePlatformList(connectedProjectData, platformList),
      )
    } else {
      setFilteredPlatformList(platformList)
    }
  }, [productType, platformList, connectedProjectData])

  useEffect(() => {
    const prevProductType = prevProductTypeRef.current
    const currentProductType = productType

    if (
      prevProductType !== undefined &&
      prevProductType !== currentProductType
    ) {
      needCheckSelectedItemRef.current = true
    }

    prevProductTypeRef.current = currentProductType
  }, [productType])

  useEffect(() => {
    if (
      currentSelectedItem &&
      !filteredPlatformList.some(
        (item) => item.code === currentSelectedItem.code,
      )
    ) {
      setCurrentSelectedItem(null)
      changeItemList?.([])
    }
    needCheckSelectedItemRef.current = false
  }, [filteredPlatformList])

  useEffect(() => {
    if (itemsList.length > 0 && itemsList[0]) {
      const first = itemsList[0]
      setCurrentSelectedItem(first)
      console.log('first', first)
      setShowRate((first.showDiscountRate ?? '0') as '1' | '0')
    } else {
      setCurrentSelectedItem(null)
    }
  }, [changeList, itemsList.length])

  useEffect(() => {
    form.resetFields()
  }, [])
  const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  }

  const selectOptions = filteredPlatformList
    .filter((item) => !NOT_SELECT_PLATFORM.includes(item.code))
    .map((item) => {
      return {
        label: item.name,
        value: item.code,
      }
    })

  // 选择项目
  const onSelectItem = (value: string) => {
    const platformItem = filteredPlatformList.find(
      (item) => item.code === value,
    )
    setShowRate(platformItem?.showDiscountRate ?? '0')
    const item = filteredPlatformList.find((item) => item.code === value)
    if (item) {
      GET_PROJECT_FIELD({ platformCode: value }).then((res) => {
        const data = {
          ...item,
          itemFields: res.data,
        }
        setCurrentSelectedItem(data)
        // 保持兼容性，调用 changeItemList 时传入数组格式
        changeItemList?.([data])
      })
    }
  }

  const onDeleteItem = () => {
    setCurrentSelectedItem(null)
    changeItemList?.([])
  }
  return (
    <div style={{ padding: 16 }}>
      {!readOnly && !currentSelectedItem?.code && (
        <div style={{ marginBottom: '16px' }}>
          <Select
            placeholder="请选择项目"
            style={{ width: '360px' }}
            options={selectOptions}
            value={currentSelectedItem?.code}
            onChange={onSelectItem}
            showSearch
            disabled={isDetailPage}
            allowClear
            onClear={() => {
              setCurrentSelectedItem(null)
              changeItemList?.([])
            }}
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
          />
        </div>
      )}
      {currentSelectedItem && (
        <Form
          {...formItemLayout}
          form={form}
          colon={false}
          labelAlign="right"
          style={{ margin: '0 0 16px 0' }}
          onFieldsChange={onFieldsChange}
        >
          <div>
            <div style={{ marginBottom: '16px' }}>
              <span style={{ fontWeight: 'bold' }}>
                {currentSelectedItem.name}
              </span>
              {!isEditView && !readOnly && (
                <Button danger type="link" onClick={onDeleteItem}>
                  删除
                </Button>
              )}
            </div>
            {currentSelectedItem.pushRequirements && (
              <Tooltip
                placement="top"
                title={currentSelectedItem.pushRequirements}
              >
                <div className={Styles['requirements']}>
                  <span>物料推送要求:</span>
                  {currentSelectedItem.pushRequirements}
                </div>
              </Tooltip>
            )}

            <GoodsSubmissionInfo
              readOnly={readOnly}
              submissionType={submissionType}
              extendedInfoList={currentSelectedItem.itemFields}
              projectCode={currentSelectedItem.code}
              form={form}
              normalForm={normalForm}
              qualityDataList={qualityDataList}
              setQualityDataListAction={setQualityDataListAction}
              isDetailPage={isDetailPage}
              preCheckErrors={preCheckErrors}
              showRate={showRate}
              relateFieldKeySet={relateFieldKeySet}
              onRelateFieldBlur={onRelateFieldBlur}
              validationInfo={
                reportingType ? (
                  <ProjectValidationInfo
                    platformCode={currentSelectedItem.code}
                    form={form}
                    reportingType={reportingType}
                    readOnly={readOnly}
                    onConfigChange={onReportConfigChange}
                    reportFieldValues={reportFieldValues}
                  />
                ) : undefined
              }
            />
          </div>
        </Form>
      )}
    </div>
  )
}

export default AssociationItems
/*
 * @Descripttion: 关联项目信息
 * @Author: renbh
 * @Date: 2023-05-05 15:38:16
 * @LastEditors: 黄佳鑫
 * @LastEditTime: 2026-02-10 09:42:57
 */

import React, { useEffect, useState, useRef } from 'react'
import { Form, Select, Tooltip, Button } from 'antd'
import { FormInstance } from 'antd/lib/form'
import { useTypedSelector } from '../../redux/store'
import { PlatformField } from './reducer'
import Styles from './detail.module.scss'
import GoodsSubmissionInfo from './goodsSubmissionInfo.tsx'
import {
  GET_PROJECT_FIELD,
  QualityList,
  ReportFieldConfigVO,
  ReportFieldValueSubmitDTO,
} from '@/api/reportApi'
import { reportTypeEnumValue, materialTypeEnum } from '@/global/enum/product'
import { mergePlatformList } from '@/tools/util'
import { PreCheckErrors } from '@/api/MaterialApi'
import { NOT_SELECT_PLATFORM } from '@/enum'
import ProjectValidationInfo from '@/pages/materialSubmissionManage/ProjectValidationInfo'

export type ItemFieldsType =
  // 单选
  | '1'
  // 多选
  | '2'
  // 下拉
  | '3'
  // 文本
  | '4'
  // 多选级联
  | '5'

interface Props {
  form: FormInstance
  normalForm: FormInstance
  itemsList: PlatformField[]
  readOnly?: boolean
  changeItemList: (val: PlatformField[]) => void
  isEditView?: boolean // 是否为编辑页面
  displayDelBtnIndex?: number // 隐藏删除按钮
  changeList?: boolean
  onFieldsChange: () => void
  submissionType?: reportTypeEnumValue
  qualityDataList: QualityList[]
  setQualityDataListAction: (data: QualityList[]) => void
  isDetailPage?: boolean // 是否为详情页面
  preCheckErrors?: PreCheckErrors
  reportingType?: string
  onReportConfigChange?: (fields: ReportFieldConfigVO[]) => void
  reportFieldValues?: ReportFieldValueSubmitDTO[]
  relateFieldKeySet?: Set<string>
  onRelateFieldBlur?: (fieldKey: string, value: any) => void
}

const AssociationItems: React.FC<Props> = (props) => {
  const {
    form,
    normalForm,
    itemsList = [],
    readOnly = false,
    changeItemList,
    changeList,
    onFieldsChange,
    submissionType,
    qualityDataList,
    setQualityDataListAction,
    isDetailPage,
    preCheckErrors,
    isEditView,
    reportingType,
    onReportConfigChange,
    reportFieldValues,
    relateFieldKeySet,
    onRelateFieldBlur,
  } = props

  const { platformList, connectedProjectData } = useTypedSelector(
    (state) => state.goodsReducer,
  )
  // 监听 productType 字段值
  const productType = Form.useWatch('productType', normalForm)
  // 过滤后的平台列表
  const [filteredPlatformList, setFilteredPlatformList] =
    useState<PlatformField[]>(platformList)

  // 判断当前项目是否展示折扣，默认取 itemsList 第一项的 showDiscountRate
  const [showRate, setShowRate] = useState<'1' | '0'>(
    () => (itemsList[0]?.showDiscountRate ?? '0') as '1' | '0',
  )
  // 当前选中的项目（单选）
  const [currentSelectedItem, setCurrentSelectedItem] =
    useState<PlatformField | null>(itemsList.length > 0 ? itemsList[0] : null)
  // 上一次的 productType，用于检测变化
  const prevProductTypeRef = useRef<string | undefined>(productType)
  // 标记 productType 是否刚刚变化，需要检查选中项
  const needCheckSelectedItemRef = useRef<boolean>(false)

  /**
   * 数据来源说明：
   * - 供应商物料：platformList 与接口GET_CONNECTED_PROJECT_CODE数据合并去重后的数据
   * - 电商供应商物料：platformList 的全部数据
   *
   * 数据关系：
   * - 电商供应商物料的数据在供应商物料中一定存在
   * - 供应商物料的数据不一定在电商供应商物料中存在
   *
   * 切换逻辑：
   * - 电商供应商 → 供应商：选中数据保持不变（因为电商供应商数据在供应商中一定存在）
   * - 供应商 → 电商供应商：校验选中数据是否存在，存在则保持不变，不存在则清空
   *
   * 设计说明：
   * connectedProjectData 已在登录时通过 Redux 缓存，无需每次切换类型时重新获取。
   * 当前未实现分别缓存各类型数据的功能，如需实现需要缓存两份数据并修改父组件逻辑，影响面较大。
   * (已与侯夏琳沟通过该需求，若后续有强烈需求，需要重新设计。)
   */

  useEffect(() => {
    if (materialTypeEnum.isLabelsMatchValue(['供应商物料'], productType)) {
      setFilteredPlatformList(
        mergePlatformList(connectedProjectData, platformList),
      )
    } else {
      setFilteredPlatformList(platformList)
    }
  }, [productType, platformList, connectedProjectData])

  useEffect(() => {
    const prevProductType = prevProductTypeRef.current
    const currentProductType = productType

    if (
      prevProductType !== undefined &&
      prevProductType !== currentProductType
    ) {
      needCheckSelectedItemRef.current = true
    }

    prevProductTypeRef.current = currentProductType
  }, [productType])

  useEffect(() => {
    if (
      currentSelectedItem &&
      !filteredPlatformList.some(
        (item) => item.code === currentSelectedItem.code,
      )
    ) {
      setCurrentSelectedItem(null)
      changeItemList?.([])
    }
    needCheckSelectedItemRef.current = false
  }, [filteredPlatformList])

  useEffect(() => {
    if (itemsList.length > 0 && itemsList[0]) {
      const first = itemsList[0]
      setCurrentSelectedItem(first)
      console.log('first', first)
      setShowRate((first.showDiscountRate ?? '0') as '1' | '0')
    } else {
      setCurrentSelectedItem(null)
    }
  }, [changeList, itemsList.length])

  useEffect(() => {
    form.resetFields()
  }, [])
  const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  }

  const selectOptions = filteredPlatformList
    .filter((item) => !NOT_SELECT_PLATFORM.includes(item.code))
    .map((item) => {
      return {
        label: item.name,
        value: item.code,
      }
    })

  // 选择项目
  const onSelectItem = (value: string) => {
    const platformItem = filteredPlatformList.find(
      (item) => item.code === value,
    )
    setShowRate(platformItem?.showDiscountRate ?? '0')
    const item = filteredPlatformList.find((item) => item.code === value)
    if (item) {
      GET_PROJECT_FIELD({ platformCode: value }).then((res) => {
        const data = {
          ...item,
          itemFields: res.data,
        }
        setCurrentSelectedItem(data)
        // 保持兼容性，调用 changeItemList 时传入数组格式
        changeItemList?.([data])
      })
    }
  }

  const onDeleteItem = () => {
    setCurrentSelectedItem(null)
    changeItemList?.([])
  }
  return (
    <div style={{ padding: 16 }}>
      {!readOnly && !currentSelectedItem?.code && (
        <div style={{ marginBottom: '16px' }}>
          <Select
            placeholder="请选择项目"
            style={{ width: '360px' }}
            options={selectOptions}
            value={currentSelectedItem?.code}
            onChange={onSelectItem}
            showSearch
            disabled={isDetailPage}
            allowClear
            onClear={() => {
              setCurrentSelectedItem(null)
              changeItemList?.([])
            }}
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
          />
        </div>
      )}
      {currentSelectedItem && (
        <Form
          {...formItemLayout}
          form={form}
          colon={false}
          labelAlign="right"
          style={{ margin: '0 0 16px 0' }}
          onFieldsChange={onFieldsChange}
        >
          <div>
            <div style={{ marginBottom: '16px' }}>
              <span style={{ fontWeight: 'bold' }}>
                {currentSelectedItem.name}
              </span>
              {!isEditView && !readOnly && (
                <Button danger type="link" onClick={onDeleteItem}>
                  删除
                </Button>
              )}
            </div>
            {currentSelectedItem.pushRequirements && (
              <Tooltip
                placement="top"
                title={currentSelectedItem.pushRequirements}
              >
                <div className={Styles['requirements']}>
                  <span>物料推送要求:</span>
                  {currentSelectedItem.pushRequirements}
                </div>
              </Tooltip>
            )}

            <GoodsSubmissionInfo
              readOnly={readOnly}
              submissionType={submissionType}
              extendedInfoList={currentSelectedItem.itemFields}
              projectCode={currentSelectedItem.code}
              form={form}
              normalForm={normalForm}
              qualityDataList={qualityDataList}
              setQualityDataListAction={setQualityDataListAction}
              isDetailPage={isDetailPage}
              preCheckErrors={preCheckErrors}
              showRate={showRate}
              relateFieldKeySet={relateFieldKeySet}
              onRelateFieldBlur={onRelateFieldBlur}
              validationInfo={
                reportingType ? (
                  <ProjectValidationInfo
                    platformCode={currentSelectedItem.code}
                    form={form}
                    reportingType={reportingType}
                    readOnly={readOnly}
                    onConfigChange={onReportConfigChange}
                    reportFieldValues={reportFieldValues}
                  />
                ) : undefined
              }
            />
          </div>
        </Form>
      )}
    </div>
  )
}

export default AssociationItems
